module.exports = "a:link {\n    text-decoration: none;\n}"